export default "__VITE_ASSET__BBbPmqaw__"